/*
  Personnalisation Foloxy : champs de personnalisation codés dans le thème, à la place de YMQ.
  Configuration (champ produit foloxy.personnalisation, JSON) :
  {
    "titre": "Choisissez votre cœur, pierre, signe ou initiale", "titre_en": "…",
    "apercu": true, "apercu_titre": "Aperçu de votre collier", "apercu_titre_en": "…",
    "listes": { "breloques": [ { "nom": "Cœur rouge", "nom_en": "Red heart", "image": "https://…" }, { "nom": "A" } ] },
    "champs": [
      { "type": "liste", "nom": "Breloque 1", "nom_en": "Charm 1", "liste": "breloques", "obligatoire": true,
        "si": { "option": "Nombre de breloques", "min": 1 } },
      { "type": "boutons", "nom": "Couleur", "liste": "couleurs", "obligatoire": true,
        "si": { "option": "Offre", "valeurs": ["1 collier"] } },
      { "type": "texte", "nom": "Son prénom", "max": 12, "obligatoire": true, "exemple": "Ex. Léo", "exemple_en": "E.g. Leo" },
      { "type": "aide", "nom": "Tableau des tailles", "image": "https://…" }
    ]
  }
  Types : liste (menu déroulant avec images), boutons (choix en boutons, avec image si fournie),
  texte (case texte), aide (lien qui ouvre une image, rien n'est envoyé).
  Condition « si » : option de variante Shopify, repérée par sa « position » (1 = première option),
  car le nom est traduit sur /en-gb et /en-us (« option » sert de repère et de secours).
  « min » compare le premier nombre de la valeur (« 3 pieces » = 3, « Aucun » = jamais) ;
  « indices » liste les positions des valeurs acceptées (0 = première valeur), valable dans toutes
  les langues ; « valeurs » (texte exact) reste possible pour une boutique sans traduction.
  Étapes (facultatif, ex. Bracelet Cuir) : le sélecteur de variantes de Shopify est masqué et remplacé
  par des étapes numérotées dans un cadre, puis les champs ci-dessus en dernière étape :
    "etapes": [
      { "position": 1, "titre": "Style", "type": "images",
        "valeurs": [ { "nom": "Noir", "nom_en": "Black", "image": "https://…" }, … ] },
      { "position": 2, "titre": "Taille", "titre_en": "Size", "type": "lignes",
        "valeurs": [ { "nom": "Standard", "detail": "21 cm · convient à la plupart", "detail_en": "…" }, … ],
        "note": "Vous hésitez ? **Standard** convient à la plupart des hommes.", "note_en": "…" },
      { "position": 2, "titre": "Nombre de pièces", "type": "boutons", "image": "variante",
        "valeurs": [ { "nom": "2 pièces", "nom_en": "2 pieces" }, … ] }
    ],
    "etape_perso": { "titre": "Vos noms", "titre_en": "Your names", "texte": "…", "texte_en": "…" }
  Types d'étape : images (cartes avec photo, 2 par ligne, 3 par ligne s'il y a 3 valeurs), lignes
  (une ligne par valeur avec un détail), boutons (petites cases côte à côte, ex. 2 à 8 pièces).
  "image": "variante" sur une étape : chaque case (ou carte sans image) montre la photo de la variante
  Shopify correspondante, compte tenu des autres choix (ex. les pièces dans la couleur choisie) ; la photo
  change quand l'autre option change. Il faut une photo par variante dans Shopify.
  « valeurs » suit l'ordre des valeurs de l'option dans Shopify (1re valeur, 2e…), pas leur texte,
  qui est traduit selon le marché. Dans les notes, **texte** s'affiche en gras.
  Langue : sur la version anglaise de la boutique (balise html lang="en…"), les clés *_en sont utilisées ;
  sur le marché US (Shopify.country = "US"), une clé *_us passe devant *_en (ex. "Colour" / "Color").
  Chaque champ part dans la commande comme propriété de l'article : properties[<nom affiché>].
  Un champ masqué (condition non remplie) est désactivé et n'est donc pas envoyé.
*/
(() => {
  if (window.__foloxyPerso) return;
  window.__foloxyPerso = true;

  const EN = /^en/i.test(document.documentElement.lang || '');
  const US = EN && !!(window.Shopify && window.Shopify.country === 'US');
  const T = EN
    ? { choisir: '--Select--', erreurChoix: 'Please make a choice', erreurTexte: 'Please fill in this field', apercu: 'Preview of your jewellery', fermer: 'Close' }
    : { choisir: '--Sélectionner--', erreurChoix: 'Faites votre choix', erreurTexte: 'Remplissez ce champ', apercu: 'Aperçu de votre bijou', fermer: 'Fermer' };
  const tr = (obj, cle) => (obj ? (US && obj[`${cle}_us`]) || (EN && obj[`${cle}_en`]) || obj[cle] : '');

  const lire = (el, sel) => {
    try {
      return JSON.parse(el.querySelector(sel).textContent);
    } catch (e) {
      return null;
    }
  };
  const creer = (tag, cls, texte) => {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (texte != null) e.textContent = texte;
    return e;
  };
  const urlSure = (u) => typeof u === 'string' && /^https:\/\/[^\s"'<>]+$/.test(u);
  const miniature = (u, taille) => u.replace(/(\.\w+)(\?|$)/, `_${taille}x${taille}$1$2`);

  function vignette(choix) {
    const v = creer('span', 'foloxy-perso__vignette');
    if (choix && urlSure(choix.image)) {
      const img = creer('img');
      img.src = miniature(choix.image, 120);
      img.alt = '';
      v.appendChild(img);
    } else if (choix) {
      v.classList.add('foloxy-perso__vignette--lettre');
      v.textContent = tr(choix, 'nom');
    }
    return v;
  }

  function initialiser(racine) {
    const config = lire(racine, '[data-foloxy-config]');
    if (!config || !Array.isArray(config.champs) || !config.champs.length) return;
    const options = (lire(racine, '[data-foloxy-options]') || []).map((o) => (typeof o === 'string' ? { n: o, v: [] } : o));
    const nomsOptions = options.map((o) => o.n);
    let valeursVariante = lire(racine, '[data-foloxy-variant]') || [];
    // Shopify donne les photos sans protocole (//foloxy.com/…) : on complète avant de les accepter.
    const variantes = (lire(racine, '[data-foloxy-variantes]') || [])
      .map((v) => (v && typeof v.i === 'string' && v.i.startsWith('//') ? { ...v, i: `https:${v.i}` } : v))
      .filter((v) => v && Array.isArray(v.o) && urlSure(v.i));
    // Étapes avec photos de variantes : on précharge toutes les photos (petites, ~20 Ko) une fois la
    // page chargée, pour que les changements de couleur ou de nombre de pièces soient instantanés.
    if (Array.isArray(config.etapes) && config.etapes.some((et) => et && et.image === 'variante') && variantes.length) {
      const precharger = () => variantes.forEach((v) => { const img = new Image(); img.src = v.i; });
      if (document.readyState === 'complete') setTimeout(precharger, 0);
      else window.addEventListener('load', precharger, { once: true });
    }
    const form = racine.closest('form');
    document.documentElement.classList.add('foloxy-perso-actif');

    // YMQ ne doit plus rien afficher ni contrôler sur ce produit.
    const retirerYmq = () => document.querySelectorAll('.ymq-options-box').forEach((b) => b.remove());
    retirerYmq();
    const obs = new MutationObserver(retirerYmq);
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 15000);

    // Position (0, 1, 2) de l'option visée : « position » de la configuration, sinon son nom.
    const indexOption = (si) => (si.position ? Number(si.position) - 1 : nomsOptions.indexOf(si.option));
    const valeurIndex = (i) => {
      if (i < 0 || i >= nomsOptions.length) return null;
      const nom = nomsOptions[i];
      const champ = document.querySelector(`[name="options[${CSS.escape(nom)}]"]:checked, select[name="options[${CSS.escape(nom)}]"]`);
      return (champ && champ.value) || valeursVariante[i] || null;
    };

    // Photo de la variante qui a la j-ième valeur de l'option i et les valeurs choisies pour les autres
    // options (sinon n'importe quelle variante avec cette valeur).
    const imageVariante = (i, j) => {
      const voulu = nomsOptions.map((_, k) => (k === i ? options[i].v[j] : valeurIndex(k)));
      const exact = variantes.find((v) => voulu.every((x, k) => x == null || v.o[k] === x));
      const sinon = exact || variantes.find((v) => v.o[i] === options[i].v[j]);
      return sinon ? sinon.i : '';
    };

    // Mode étapes : options de variante en cartes ou en lignes, puis les champs en dernière étape.
    const etapes = Array.isArray(config.etapes) ? config.etapes : [];
    let conteneur = racine;
    const boutonsEtapes = [];
    if (etapes.length) {
      // Le sélecteur natif est reconstruit à chaque changement de variante : on le masque par un
      // ancêtre qui, lui, reste en place.
      (racine.closest('product-info') || document.documentElement).classList.add('foloxy-perso-etapes');
      racine.classList.add('foloxy-perso--etapes');
      const entete = (numero, titre) => {
        const h = creer('div', 'foloxy-perso__etape-entete');
        h.append(creer('span', 'foloxy-perso__etape-numero', String(numero)), creer('p', 'foloxy-perso__etape-titre', titre));
        return h;
      };
      const texteGras = (texte) => {
        const p = creer('p', 'foloxy-perso__etape-note');
        String(texte).split('**').forEach((morceau, i) => p.appendChild(i % 2 ? creer('strong', '', morceau) : document.createTextNode(morceau)));
        return p;
      };
      etapes.forEach((et, n) => {
        const i = Number(et.position) - 1;
        if (!options[i]) return;
        const bloc = creer('div', 'foloxy-perso__etape');
        bloc.appendChild(entete(n + 1, tr(et, 'titre') || options[i].n));
        const type = et.type === 'images' || et.type === 'boutons' ? et.type : 'lignes';
        const classes = { images: ['foloxy-perso__cartes', 'foloxy-perso__carte'], boutons: ['foloxy-perso__pastilles', 'foloxy-perso__pastille'], lignes: ['foloxy-perso__lignes', 'foloxy-perso__ligne'] }[type];
        const grille = creer('div', classes[0]);
        if (type === 'images' && (options[i].v || []).length === 3) grille.classList.add('foloxy-perso__cartes--3');
        const suitVariante = et.image === 'variante' && variantes.length > 0;
        if (suitVariante && type === 'boutons') grille.classList.add('foloxy-perso__pastilles--images');
        grille.setAttribute('role', 'radiogroup');
        (options[i].v || []).forEach((valeur, j) => {
          const choix = (et.valeurs || [])[j] || {};
          const b = creer('button', classes[1]);
          b.type = 'button';
          b.setAttribute('aria-pressed', 'false');
          let imgVariante = null;
          if (type === 'images') {
            const cadre = creer('span', 'foloxy-perso__carte-image');
            if (urlSure(choix.image) || suitVariante) {
              const img = creer('img');
              img.src = urlSure(choix.image) ? choix.image : imageVariante(i, j);
              img.alt = '';
              img.loading = 'lazy';
              cadre.appendChild(img);
              if (!urlSure(choix.image)) imgVariante = img;
            }
            b.append(cadre, creer('span', 'foloxy-perso__carte-nom', tr(choix, 'nom') || valeur));
          } else if (type === 'boutons') {
            if (suitVariante) {
              b.classList.add('foloxy-perso__pastille--image');
              const cadre = creer('span', 'foloxy-perso__pastille-image');
              imgVariante = creer('img');
              imgVariante.src = imageVariante(i, j);
              imgVariante.alt = '';
              cadre.appendChild(imgVariante);
              b.appendChild(cadre);
            }
            b.appendChild(creer('span', 'foloxy-perso__pastille-nom', tr(choix, 'nom') || valeur));
            if (tr(choix, 'detail')) b.appendChild(creer('span', 'foloxy-perso__pastille-detail', tr(choix, 'detail')));
          } else {
            b.append(creer('span', 'foloxy-perso__ligne-nom', tr(choix, 'nom') || valeur), creer('span', 'foloxy-perso__ligne-detail', tr(choix, 'detail')));
          }
          b.addEventListener('click', () => choisirValeur(i, j));
          boutonsEtapes.push({ i, j, b, img: imgVariante });
          grille.appendChild(b);
        });
        bloc.appendChild(grille);
        if (tr(et, 'note')) bloc.appendChild(texteGras(tr(et, 'note')));
        racine.appendChild(bloc);
      });
      const ep = config.etape_perso || {};
      conteneur = creer('div', 'foloxy-perso__etape');
      conteneur.appendChild(entete(etapes.length + 1, tr(ep, 'titre') || tr(config, 'titre')));
      if (tr(ep, 'texte')) conteneur.appendChild(creer('p', 'foloxy-perso__etape-texte', tr(ep, 'texte')));
      racine.appendChild(conteneur);
    } else if (tr(config, 'titre')) racine.appendChild(creer('p', 'foloxy-perso__titre', tr(config, 'titre')));

    // Choisit la j-ième valeur de l'option i dans le sélecteur natif (menu ou boutons radio),
    // recherché à chaque fois puisque Dawn le reconstruit.
    function choisirValeur(i, j) {
      const nom = CSS.escape(nomsOptions[i]);
      const valeur = options[i].v[j];
      const menu = document.querySelector(`select[name="options[${nom}]"]`);
      if (menu) {
        if (menu.value === valeur) return;
        menu.value = valeur;
        menu.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const radio = [...document.querySelectorAll(`input[name="options[${nom}]"]`)].find((r) => r.value === valeur);
        if (radio && !radio.checked) radio.click();
      }
      boutonsEtapes.forEach((e) => { if (e.i === i) e.b.setAttribute('aria-pressed', String(e.j === j)); });
    }
    // État « choisi » de chaque case, et photo de la variante si l'étape suit les variantes.
    const majEtapes = () => boutonsEtapes.forEach((e) => {
      e.b.setAttribute('aria-pressed', String(valeurIndex(e.i) === options[e.i].v[e.j]));
      if (e.img) {
        const u = imageVariante(e.i, e.j);
        if (u && e.img.getAttribute('src') !== u) e.img.src = u;
      }
    });

    const etats = [];

    config.champs.forEach((c, idx) => {
      const nom = tr(c, 'nom');
      const bloc = creer('div', 'foloxy-perso__champ');
      const id = `FoloxyPerso-${racine.dataset.productId}-${idx}`;
      const erreur = creer('p', 'foloxy-perso__erreur', '');
      erreur.hidden = true;
      const etat = { c, bloc, erreur, valeur: '', input: null };
      const liste = c.liste ? (config.listes && config.listes[c.liste]) || [] : c.choix || [];

      if (c.type === 'aide') {
        // Lien qui ouvre une image (ex. tableau des tailles). Rien n'est envoyé dans la commande.
        bloc.classList.add('foloxy-perso__champ--aide');
        const lien = creer('button', 'foloxy-perso__aide', nom);
        lien.type = 'button';
        const fenetre = creer('dialog', 'foloxy-perso__fenetre');
        const fermer = creer('button', 'foloxy-perso__fenetre-fermer', '×');
        fermer.type = 'button';
        fermer.setAttribute('aria-label', T.fermer);
        fermer.addEventListener('click', () => fenetre.close());
        fenetre.appendChild(fermer);
        if (urlSure(c.image)) {
          const img = creer('img');
          img.src = c.image;
          img.alt = nom;
          fenetre.appendChild(img);
        }
        fenetre.addEventListener('click', (e) => { if (e.target === fenetre) fenetre.close(); });
        lien.addEventListener('click', () => (fenetre.showModal ? fenetre.showModal() : fenetre.setAttribute('open', '')));
        bloc.append(lien, fenetre);
        conteneur.appendChild(bloc);
        etats.push(etat);
        return;
      }

      const label = creer('label', 'foloxy-perso__label', nom);
      label.htmlFor = id;
      if (c.obligatoire) {
        const etoile = creer('span', 'foloxy-perso__requis', '*');
        etoile.setAttribute('aria-hidden', 'true');
        label.append(' ', etoile);
      }
      bloc.appendChild(label);

      const choisir = (choix, input, afficher) => {
        const valeur = tr(choix, 'nom');
        etat.valeur = valeur;
        etat.choix = choix;
        input.value = valeur;
        afficher();
        erreur.hidden = true;
        majApercu();
      };

      if (c.type === 'liste') {
        const input = creer('input');
        input.type = 'hidden';
        input.name = `properties[${nom}]`;
        const bouton = creer('button', 'foloxy-perso__select');
        bouton.type = 'button';
        bouton.id = id;
        bouton.setAttribute('aria-haspopup', 'listbox');
        bouton.setAttribute('aria-expanded', 'false');
        const affichage = creer('span', 'foloxy-perso__select-valeur', T.choisir);
        bouton.appendChild(affichage);
        bouton.appendChild(creer('span', 'foloxy-perso__fleche'));
        const panneau = creer('ul', 'foloxy-perso__panneau');
        panneau.setAttribute('role', 'listbox');
        panneau.hidden = true;
        const fermer = () => { panneau.hidden = true; bouton.setAttribute('aria-expanded', 'false'); };
        liste.forEach((choix) => {
          const li = creer('li', 'foloxy-perso__choix');
          li.setAttribute('role', 'option');
          li.tabIndex = -1;
          li.appendChild(vignette(choix));
          li.appendChild(creer('span', 'foloxy-perso__choix-nom', tr(choix, 'nom')));
          li.addEventListener('click', () => {
            choisir(choix, input, () => {
              affichage.replaceChildren(vignette(choix), creer('span', '', tr(choix, 'nom')));
              bouton.classList.add('foloxy-perso__select--rempli');
            });
            fermer();
            bouton.focus();
          });
          li.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); li.click(); }
            if (e.key === 'ArrowDown') { e.preventDefault(); (li.nextElementSibling || li).focus(); }
            if (e.key === 'ArrowUp') { e.preventDefault(); (li.previousElementSibling || li).focus(); }
            if (e.key === 'Escape') { fermer(); bouton.focus(); }
          });
          panneau.appendChild(li);
        });
        const ouvrir = () => {
          document.querySelectorAll('.foloxy-perso__panneau').forEach((p) => { if (p !== panneau) p.hidden = true; });
          panneau.hidden = false;
          bouton.setAttribute('aria-expanded', 'true');
          const actif = [...panneau.children].find((li) => li.textContent.endsWith(etat.valeur) && etat.valeur) || panneau.firstElementChild;
          if (actif) actif.focus();
        };
        bouton.addEventListener('click', () => (panneau.hidden ? ouvrir() : fermer()));
        document.addEventListener('click', (e) => { if (!bloc.contains(e.target)) fermer(); });
        const cadre = creer('div', 'foloxy-perso__liste');
        cadre.append(bouton, panneau, input);
        bloc.appendChild(cadre);
        etat.input = input;
      } else if (c.type === 'boutons') {
        const input = creer('input');
        input.type = 'hidden';
        input.name = `properties[${nom}]`;
        const grille = creer('div', 'foloxy-perso__boutons');
        grille.setAttribute('role', 'radiogroup');
        grille.id = id;
        const boutons = [];
        liste.forEach((choix) => {
          const b = creer('button', 'foloxy-perso__bouton');
          b.type = 'button';
          b.setAttribute('aria-pressed', 'false');
          if (urlSure(choix.image)) {
            b.classList.add('foloxy-perso__bouton--image');
            const img = creer('img');
            img.src = miniature(choix.image, 160);
            img.alt = '';
            b.appendChild(img);
          }
          b.appendChild(creer('span', 'foloxy-perso__bouton-nom', tr(choix, 'nom')));
          b.addEventListener('click', () => {
            choisir(choix, input, () => {
              boutons.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
            });
          });
          boutons.push(b);
          grille.appendChild(b);
        });
        bloc.append(grille, input);
        etat.input = input;
      } else {
        const input = creer('input', 'foloxy-perso__texte');
        input.type = 'text';
        input.id = id;
        input.name = `properties[${nom}]`;
        if (c.max) input.maxLength = Number(c.max);
        if (tr(c, 'exemple')) input.placeholder = tr(c, 'exemple');
        const compteur = creer('span', 'foloxy-perso__compteur', c.max ? `0/${c.max}` : '');
        input.addEventListener('input', () => {
          etat.valeur = input.value.trim();
          if (c.max) compteur.textContent = `${input.value.length}/${c.max}`;
          erreur.hidden = true;
          majApercu();
        });
        const cadre = creer('div', 'foloxy-perso__cadre-texte');
        cadre.append(input, compteur);
        bloc.appendChild(cadre);
        etat.input = input;
      }
      bloc.appendChild(erreur);
      conteneur.appendChild(bloc);
      etats.push(etat);
    });

    // Aperçu : les breloques choisies, dans l'ordre, sur une chaîne de la couleur choisie.
    let apercu = null;
    if (config.apercu) {
      apercu = creer('div', 'foloxy-perso__apercu');
      apercu.appendChild(creer('p', 'foloxy-perso__apercu-titre', tr(config, 'apercu_titre') || T.apercu));
      apercu.appendChild(creer('div', 'foloxy-perso__chaine'));
      racine.appendChild(apercu);
    }

    function visible(c) {
      if (!c.si) return true;
      const i = indexOption(c.si);
      const v = valeurIndex(i);
      if (v == null) return true;
      if (Array.isArray(c.si.indices)) return c.si.indices.map(Number).includes((options[i].v || []).indexOf(v));
      if (c.si.min != null) {
        const n = parseInt(String(v), 10);
        return Number.isFinite(n) && n >= Number(c.si.min);
      }
      if (Array.isArray(c.si.valeurs)) {
        const norme = (x) => String(x).trim().toLowerCase();
        return c.si.valeurs.some((x) => norme(x) === norme(v));
      }
      return true;
    }

    function majApercu() {
      // Couleur de l'aperçu : n'importe quelle option dont la valeur dit argent ou or rose (français ou anglais).
      const valeurs = nomsOptions.map((_, i) => String(valeurIndex(i) || '').toLowerCase()).join(' ');
      racine.dataset.couleur = /argent|silver/.test(valeurs) ? 'argent' : /rose/.test(valeurs) ? 'rose' : 'or';
      if (!apercu) return;
      const chaine = apercu.querySelector('.foloxy-perso__chaine');
      chaine.replaceChildren();
      etats.filter((e) => !e.bloc.hidden && e.c.type === 'liste').forEach((e) => {
        const place = creer('span', 'foloxy-perso__breloque');
        if (e.choix) place.appendChild(vignette(e.choix));
        else place.classList.add('foloxy-perso__breloque--vide');
        chaine.appendChild(place);
      });
    }

    function majVisibilite() {
      etats.forEach((e) => {
        const v = visible(e.c);
        e.bloc.hidden = !v;
        if (e.input) e.input.disabled = !v;
        if (!v) e.erreur.hidden = true;
      });
      majEtapes();
      majApercu();
    }

    // Changement de variante (Dawn) : abonnement interne, plus les changements directs des options.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
        const v = ev && ev.data && ev.data.variant;
        if (v && Array.isArray(v.options)) valeursVariante = v.options;
        setTimeout(majVisibilite, 0);
      });
    }
    document.addEventListener('change', (e) => {
      if (e.target && /^options\[/.test(e.target.name || '')) setTimeout(majVisibilite, 0);
    });
    majVisibilite();

    // Contrôle avant l'ajout au panier : tout champ visible et obligatoire doit être rempli.
    if (form) {
      document.addEventListener('submit', (e) => {
        if (e.target !== form) return;
        const manquants = etats.filter((s) => s.input && !s.bloc.hidden && s.c.obligatoire && !s.valeur);
        if (!manquants.length) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        manquants.forEach((s) => {
          s.erreur.textContent = s.c.type === 'texte' || !s.c.type ? T.erreurTexte : T.erreurChoix;
          s.erreur.hidden = false;
        });
        manquants[0].bloc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);
    }
  }

  const demarrer = () => document.querySelectorAll('[data-foloxy-perso]').forEach(initialiser);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
